export enum CustomErrors {
  LastAdminUser = 'Roles.LastAdminUser',
  CustomFieldNotFound = 'CustomFields.NotFound',
  DuplicateOptions ='Option Values must be unique'
}